import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { seconds2HMS } from 'src/components/utils/utils';
import { abbreviate } from 'src/components/utils/utils';
import { statusColors } from 'src/components/utils/consts';
class UserImage extends Component {

    constructor(props) {
        super(props);
        this.renderStatus = this.renderStatus.bind(this);
    }

    renderStatus(data) {

        if (data.strAcdStatus === "LoggedOut")
            data.strAcdStatus = data.ext !== null && data.ext.length > 0 ? "Unregistered" : data.strAcdStatus;

        if (data.strAcdStatus === "Wrapup" && data.strStatus === "Talking")
            data.strAcdStatus = "Free";

        let ret = this.props.t('loggedout'),
            diff = 0,
            acdStatusChanged = new Date();

        acdStatusChanged.setSeconds(acdStatusChanged.getSeconds() - this.props.agent.timeDiffAcdStatus);
        diff = Math.floor((Date.now() - acdStatusChanged) / 1000);
        switch (this.props.agent.strAcdStatus) {
            case "Free":
                ret = this.props.t('registered') + ' - ' + seconds2HMS(this.props.agent.timeDiffAcdStatus);
                break;
            case "Paused":
                diff = Math.floor((Date.now() - acdStatusChanged) / 1000);
                ret = this.props.t('paused');
                if (this.props.agent.pauseType !== null && this.props.agent.pauseType !== "")
                    ret += ' - ' + this.props.agent.pauseType;

                ret += ' - ' + seconds2HMS(diff);
                break;
            case 'Wrapup':
                ret = this.props.t('wrapup');
                break;
            case 'Unregistered':
                ret = this.props.t('unregistered');
                break;
            default:
                ret = this.props.t('loggedout');
                break;
        };

        return (<Tooltip style={{ position: "fixed" }} {...data}>{ret}</Tooltip>);

    }
    render() {
        return (<OverlayTrigger
            placement="left"
            delay={{ show: 250, hide: 400 }}
            overlay={this.renderStatus}>
            <div className="symbol symbol-50px me-3">
                {
                    (!this.props.agent.photo) &&
                    <div className='user-img text-primary bg-light-primary'>{abbreviate(this.props.agent.fullName || this.props.agent.name)}</div>
                }

                {
                    (this.props.agent.photo) &&
                    <img src={`//${this.props.agent.photo}`} alt="agent" />
                }
                <div className={"position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-body h-20px w-20px bg-" + statusColors[this.props.agent.strAcdStatus.toLowerCase()]}></div>
            </div>
        </OverlayTrigger>)
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
    };
};
export default compose(connect(mapStateToProps, null), withTranslation())(UserImage);